// Copyright (c) 2020 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import {
  SearchRecentNarrativesRequest,
  SearchRecentNarrativesResponse,
} from "generated/wisetime/user/preferences/v4/preferences_pb"
import { grpc } from "../../../app/rpc/executor"
import { preferencesClient } from "../../../app/rpc/client"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type SearchRecentNarrativesRpc = (request: SearchRecentNarrativesRequest) => Observable<SearchRecentNarrativesResponse>

export const searchRecentNarratives = (searchRecentNarrativesRpc: SearchRecentNarrativesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.searchRecentNarratives.match),
      mergeMap(action => of(action.payload).pipe(
        mergeMap(searchRecentNarrativesRpc),
        map(t => t.toObject()),
        map(Slice.setCachedNarratives),
        catchError(_ => of(showSnackBar({
          message: t({ id: "msg_search_descriptions_failed", message: "Failed to search for descriptions. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
          messageType: "ERROR",
        }))),
      )),
    )

const searchRecentNarrativesRpc = (request: SearchRecentNarrativesRequest): Observable<SearchRecentNarrativesResponse> =>
  grpc(() => preferencesClient.searchRecentNarratives(request, null))

export default searchRecentNarratives(searchRecentNarrativesRpc)
